var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-qa":"error page"}},[_c('ErrorMessage',{attrs:{"data-qa":"error message container","error":_vm.error}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }